import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { DeviceService } from "@src/app/servicios/device/device.service";
import { catchError, first, Observable, of, switchMap } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";

let deviceService;
let configService;

export const DeviceBasedResolver: ResolveFn<any> = (): Observable<boolean> => {
  configService = inject(ConfigService);
  deviceService = inject(DeviceService);

  // Comprueba si la portada de reels está activa en la configuración y si el dispositivo es móvil.
  const configPrensa = configService.getConfigPrensa();
  if (configPrensa) {
    return configPrensa.pipe(
      first(),
      switchMap((resultConfig: any) => {
        if (resultConfig) {
          const portadaReels = resultConfig.general["app-home"].portada_reels_movil === "true";
          if (!portadaReels) {
            return of(false);
          }
          if (deviceService.isMobile()) {
            return deviceService.isMobile().pipe(first());
          }
        } else {
          return of(false);
        }
      }),
      catchError(() => of(false)),
    );
  }
};
